const isClipPathInsetSupported = (): boolean => {
    const base = 'clipPath',
        prefixes = ['webkit', 'moz', 'ms', 'o'],
        properties = [base],
        testElement = document.createElement('div'),
        attribute = 'inset(0)';

    // Push the prefixed properties into the array of properties.
    for (let i = 0, l = prefixes.length; i < l; i++) {
        const prefixedProperty =
            prefixes[i] + base.charAt(0).toUpperCase() + base.slice(1); // remember to capitalize!
        properties.push(prefixedProperty);
    }

    // Interate over the properties and see if they pass two tests.
    for (let i = 0, l = properties.length; i < l; i++) {
        const property: 'clipPath' = properties[i] as any;
        const style: any = testElement.style; // https://github.com/facebook/flow/issues/3733

        // First, they need to even support clip-path (IE <= 11 does not)...
        if (style[property] === '') {
            // Second, we need to see what happens when we try to create a CSS shape...
            style[property] = attribute;
            if (style[property] !== '') {
                return true;
            }
        }
    }

    return false;
};

export default isClipPathInsetSupported();
